const ALLERGENS_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: undefined,
}

export default ALLERGENS_INITIAL_STATE
